var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListCheck = function SvgListCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.864 5.50387L12.512 18.1073C11.7631 19.391 9.92533 19.4385 9.11121 18.1951L4.16357 10.6387L5.83681 9.54313L10.7844 17.0995L18.1364 4.49613L19.864 5.50387Z",
    fill: "var(--on-surface)"
  })));
};
export default SvgListCheck;